import { Component, OnInit } from '@angular/core';
import appVersion from '../../../package.json';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
})
export class HeaderComponent implements OnInit {
  public version: string = appVersion.version;

  ngOnInit(): void {}
}
